<template>
    <div class="pathogenicity-bar-wrapper">
        <div class="pathogenicity-bar" ref="pathogenicity_bar" v-if="value">
            <span class="mx-auto">{{value}}</span>
        </div>
    </div>
    
</template>

<script setup lang="js">
import { onMounted, ref } from 'vue';

const props = defineProps({
    min: Number,
    max: Number,
    value: Number,
    mode: String,
})

/**
 * Calculates the percentage of the given value in between a set minimum and maximum (default 0-1).
 * Then draws the according gradient into the pathogenicity bar.
 */
onMounted(() => {
    if (props.value) {
        let pc = ((props.value - (props.min ? props.min : 0)) * 100) / ((props.max ? props.max : 1) - (props.min ? props.min : 0))
        if (pathogenicity_bar.value && pc >= 0 && pc <= 100) {
            if (props.mode == 'vuspredict') {
                let gc = determineGradientColor(pc, true);
                pathogenicity_bar.value.style.background =`linear-gradient(to left, #fff 0%, #fff ${pc}%, ${gc} ${pc-1}%, #fff 150%)`;
        
            } else {
                let gc = determineGradientColor(pc);
                pathogenicity_bar.value.style.background = `linear-gradient(to right, #fff -50%, ${gc} ${pc}%, #fff ${pc+1}%, #fff 100%)`;
            }
                
        }
            
    }   
})

/**
 * Determines the gradient color given the mode (props.mode) and the calculated percentage (see onMounted section)
 * @param {number} pc - The calculated percentage of the pathogenicity bar to fill with the gradient 
 */
const determineGradientColor = (pc, vus=false) => {
 if (pc < 50) return (props?.mode == "inverted" || vus ? "var(--pathogenic)" : "var(--light-grey)");
 else return (props?.mode == "inverted" || vus ? "var(--light-grey)" : "var(--pathogenic)");
}

const pathogenicity_bar = ref()
</script>

<style scoped>
.pathogenicity-bar-wrapper {
    padding: 8px;
}

.pathogenicity-bar {
    display: flex;
    align-items: center;
    text-align: center;
    height: 1.5rem;
    width: 6em;
    margin: 8px 8px;
    background: linear-gradient(to left, #9c9e9f 0%,#9c9e9f 50%,#f6f6f6 50%,#f6f6f6 100%);
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 2px 0px;
}

@media (max-width: 1300px) {

.pathogenicity-bar-wrapper {
    scale: 0.9 0.9;
}

}

@media (max-width: 900px) {

.pathogenicity-bar-wrapper {
    scale: 0.8 0.8;
}

}

</style>
